<template>
  <nuxt/>
</template>
<script>
import cioPageTracking from '~/plugins/mixins/cioPageTracking'
export default {
  mixins: [cioPageTracking]
}
</script>
